// https://github.com/giantcz/gia
// Add import to js/components
import { gsap, TweenMax } from "gsap/all";
import Component from 'gia/Component'

export default class ParallaxComponent extends Component {
  
  constructor(element) {
    super(element);

    this.titleFactor = -30;
    this.canFactor = -50;
    this.flourishFactor = -115;
    this.squareFactor = -15;

    this.ref = {
      drinks: []
    }
  }
  
  mount() {
    this.init()
  }
  
  init() {
    const parallaxArr = Array.prototype.slice.call(this.ref.drinks);
    
    if (parallaxArr.length > 0) {
      const mouse = [];
      const rect = [];
      parallaxArr.forEach(function (container, index) {
        rect[index] = container.getBoundingClientRect();
        mouse[index] = { x: 0, y: 0, moved: false };
        
        
        jQuery(container).on('mousemove', function (e) {
          mouse[index].moved = true;
          mouse[index].x = e.clientX - rect[index].left;
          mouse[index].y = e.clientY - rect[index].top;
        });
        
        jQuery(container).on('mouseleave', function (e) {
          mouse[index].moved = false;
          mouse[index].x = 0;
          mouse[index].y = 0;
          if (jQuery(container).find('.cocktail-title')) {
            resetIt(jQuery(container).find('.cocktail-title h2'));
          }
          resetIt(jQuery(container).find('.cocktail-can'));
          resetIt(jQuery(container).find('.flourish'));
          resetIt(jQuery(container).find('.square'));
        });
        
        // Ticker event will be called on every frame
        gsap.ticker.add(function () {
          if (mouse[index].moved) {
            if (jQuery(container).find('.cocktail-title')) {
              parallaxIt(jQuery(container).find('.cocktail-title h2'), -15, mouse[index], rect[index]);
            }
            parallaxIt(jQuery(container).find('.cocktail-can'), -25, mouse[index], rect[index]);
            parallaxIt(jQuery(container).find('.flourish'), -60, mouse[index], rect[index]);
            parallaxIt(jQuery(container).find('.square'), -10, mouse[index], rect[index]);
          }
          mouse[index].moved = false;
        });
        
        jQuery(window).on('resize scroll', function () {
          rect[index] = container.getBoundingClientRect();
        })
      });
      
      function resetIt(target) {
        TweenMax.to(target, 0.5, {
          x: 0 / 0,
          y: 0 / 0
        });
      }
      
      function parallaxIt(target, movement, mouse, rect) {
        TweenMax.to(target, 2.0, {
          x: (mouse.x - rect.width / 2) / rect.width * movement,
          y: (mouse.y - rect.height / 2) / rect.height * movement
        });
      }
    }
  }
}